import { render, staticRenderFns } from "./mobile-noteall.vue?vue&type=template&id=512230b6&"
import script from "./mobile-noteall.vue?vue&type=script&lang=js&"
export * from "./mobile-noteall.vue?vue&type=script&lang=js&"
import style0 from "./mobile-noteall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports